import { NgModule } from "@angular/core";
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
//
import { InteractConfirmComponent } from './components/interact-confirm/interact-confirm.component';
import { InteractConfirmButtonsComponent } from './components/interact-confirm-buttons/interact-confirm-buttons.component';
import { InteractDialogComponent } from './components/interact-dialog/interact-dialog.component';
import { InteractLoadingComponent } from './components/interact-loading/interact-loading.component';
import { InteractPromptComponent } from './components/interact-prompt/interact-prompt.component';
import { SharedModule } from './shared.module';
import { MatInputModule } from '@angular/material/input';
// ProtoTypes
import '../prototypes/string';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatBadgeModule } from '@angular/material/badge';

export const MY_DATE_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@NgModule({
    declarations: [
        AppComponent, InteractConfirmComponent, InteractDialogComponent, InteractLoadingComponent, InteractPromptComponent, InteractConfirmButtonsComponent,
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        BrowserTransferStateModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        //
        MatIconModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        FormsModule,
        MatDialogModule,
        MatSnackBarModule,
        MatBadgeModule,
        SharedModule,
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        // { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
